/* import __COLOCATED_TEMPLATE__ from './class-group-editor-card.hbs'; */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import { computed } from '@ember/object';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';

dayjs.extend(customParseFormat);

export default class ClassGroupEditorCardComponent extends Component 
{
	@service store;
	
	@tracked startTime;
	@tracked endTime;
	@tracked postTime;
	
	@tracked isEditingStartTime = false;
	@tracked isEditingEndTime = false;
	@tracked isEditingPostTime = false;
	
	updateStartTime()
	{
		if (!this.args.classGroup) {
			return;
		}
		if(this.args.classGroup.startTime == undefined)
		{
			this.startTime = null;
		}
		else
		{
			this.startTime = dayjs(this.args.classGroup.startTime).format("HH:mm:ss");
			if(this.startTime == "Invalid date")
				this.startTime = null;
		}
	}
	
	updateEndTime()
	{
		if (!this.args.classGroup) {
			return;
		}
		if(this.args.classGroup.endTime == undefined)
		{
			this.endTime = null;
		}
		else
		{
			this.endTime = dayjs(this.args.classGroup.endTime).format("HH:mm:ss");
			if(this.endTime == "Invalid date")
				this.endTime = null;
		}
	}
	
	updatePostTime()
	{
		if (!this.args.classGroup) {
			return;
		}
		if(this.args.classGroup.postTime == undefined)
		{
			this.postTime = null;
		}
		else
		{
			this.postTime = dayjs(this.args.classGroup.postTime).format("HH:mm:ss");
			if(this.postTime == "Invalid date")
				this.postTime = null;
		}
	}
	
	@action
	inserted()
	{
		this.updateStartTime();
		this.updateEndTime();
		this.updatePostTime();
	}
	
	@action
	toggleEditingStartTime()
	{
		this.isEditingStartTime = !this.isEditingStartTime;
	}
	
	@action
	toggleEditingEndTime()
	{
		this.isEditingEndTime = !this.isEditingEndTime;
	}
	
	@action
	toggleEditingPostTime()
	{
		this.isEditingPostTime = !this.isEditingPostTime;
	}
	
	@action
	cancelEditingStartTime()
	{
		if(this.isEditingStartTime)
		{
			this.updateStartTime();
		}
		this.isEditingStartTime = false;
	}
	
	@action
	cancelEditingPostTime()
	{
		if(this.isEditingPostTime)
		{
			this.updatePostTime();
		}
		this.isEditingPostTime = false;
	}
	
	@action
	cancelEditingEndTime()
	{
		if(this.isEditingEndTime)
		{
			this.updateEndTime();
		}
		this.isEditingEndTime = false;
	}
	
	@action
	async saveStartTime(browserEvent)
	{
		browserEvent.preventDefault();
		
		if(this.isEditingStartTime)
		{
			var startTimeEntered = this.startTime;
			if(startTimeEntered == "")
			{
				this.args.classGroup.startTime = null;
			}
			else
			{
				var parsedStartTime = dayjs(startTimeEntered, "HH:mm:ss");

				var eventDate = dayjs(this.args.classGroup.get('EventId.date'));
				parsedStartTime = parsedStartTime
					.year(eventDate.year())
					.month(eventDate.month())
					.date(eventDate.date());
				this.args.classGroup.startTime = new Date(parsedStartTime.toISOString());
			}
			try
			{
				await this.args.classGroup.save();
			}
			catch (error)
			{
				alert(error);
				this.args.classGroup.rollbackAttributes();
			}
			
		
			this.updateStartTime();
		}
		this.isEditingStartTime = false;
	}
	
	@action
	async saveEndTime(browserEvent)
	{
		browserEvent.preventDefault();
		
		if(this.isEditingEndTime)
		{
			var endTimeEntered = this.endTime;
			if(endTimeEntered == "")
			{
				this.args.classGroup.endTime = null;
			}
			else
			{
				var parsedEndTime = dayjs(endTimeEntered, "HH:mm:ss");

				var eventDate = dayjs(this.args.classGroup.get('EventId.date'));
				parsedEndTime = parsedEndTime
					.year(eventDate.year())
					.month(eventDate.month())
					.date(eventDate.date());
				this.args.classGroup.endTime = new Date(parsedEndTime.toISOString());
			}
			try
			{
				await this.args.classGroup.save();
			}
			catch (error)
			{
				alert(error);
				this.args.classGroup.rollbackAttributes();
			}
		
			this.updateEndTime();
		}
		this.isEditingEndTime = false;
	}
	
	@action
	async savePostTime(browserEvent)
	{
		browserEvent.preventDefault();
		
		if(this.isEditingPostTime)
		{
			var postTimeEntered = this.postTime;
			if(postTimeEntered == "")
			{
				this.args.classGroup.postTime = null;
			}
			else
			{
				var parsedPostTime = dayjs(postTimeEntered, "HH:mm:ss");

				var eventDate = dayjs(this.args.classGroup.get('EventId.date'));
				parsedPostTime = parsedPostTime
					.year(eventDate.year())
					.month(eventDate.month())
					.date(eventDate.date());
				this.args.classGroup.postTime = new Date(parsedPostTime.toISOString());
			}
			try
			{
				await this.args.classGroup.save();
			}
			catch (error)
			{
				alert(error);
				this.args.classGroup.rollbackAttributes();
			}
		
			this.updatePostTime();
		}
		this.isEditingPostTime = false;
	}
}